import type { CustomIconProps } from '../CustomIcon';

export const TagIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  unfilled,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='m20.59 13.41-7.17 7.17a1.998 1.998 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z'
        fill={unfilled ? 'none' : color}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 7h.01'
        stroke={secondaryColor}
        strokeWidth={3}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
